module.exports = __webpack_public_path__ + "img/bycicle-cargo.f354b206.svg";